import { render, staticRenderFns } from "./CalculationGeniusPanel.vue?vue&type=template&id=6afb607c&scoped=true&"
import script from "./CalculationGeniusPanel.vue?vue&type=script&lang=js&"
export * from "./CalculationGeniusPanel.vue?vue&type=script&lang=js&"
import style0 from "./CalculationGeniusPanel.vue?vue&type=style&index=0&id=6afb607c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb607c",
  null
  
)

export default component.exports